'use client';

import { memo } from 'react';
import type { WalletTransaction } from '../../types';
import { useFormattedDateLabel } from '../hooks/useFormattedDateLabel';
import type { DayKey } from '../types';
import { TransactionItem } from './TransactionItem';

type DaySectionProps = { day: DayKey; transactions: WalletTransaction[]; namespace: string };

const DaySection = memo(function DaySection({ day, transactions, namespace }: DaySectionProps) {
  const dayHeader = useFormattedDateLabel(namespace, new Date(day), 'day_header');

  return (
    <div className="flex flex-col gap-3" data-testid={`day-title-${day}`}>
      <p className="paragraph-explanatory-strong" data-testid="day-section-title">
        {dayHeader}
      </p>
      {transactions.map(transaction => (
        <TransactionItem key={transaction.date} namespace={namespace} transaction={transaction} />
      ))}
    </div>
  );
});

export { DaySection };
